import React from 'react';
import PropTypes from 'prop-types';
import {
  RadioGroup,
  Toggle,
} from '@makeably/creativex-design-system';
import Collapsible from 'components/molecules/Collapsible';
import {
  toPercent,
  titleize,
} from 'utilities/string';

export const FILL_COLORS = ['blue', 'green'];
export const LINE_COLORS = ['white', 'black'];

const propTypes = {
  gridFillColor: PropTypes.oneOf(FILL_COLORS).isRequired,
  gridLineColor: PropTypes.oneOf(LINE_COLORS).isRequired,
  onGridFillColorChange: PropTypes.func.isRequired,
  onGridLineColorChange: PropTypes.func.isRequired,
  onShowGridChange: PropTypes.func.isRequired,
  selectedRatio: PropTypes.number.isRequired,
  showGrid: PropTypes.bool.isRequired,
};

function getOptions(values) {
  return values.map((value) => ({
    label: titleize(value),
    value,
  }));
}

function GridControls({
  gridFillColor,
  gridLineColor,
  onGridFillColorChange,
  onGridLineColorChange,
  onShowGridChange,
  selectedRatio,
  showGrid,
}) {
  const renderHeader = () => (
    <div className="u-flexRow u-alignCenter u-gap-16 u-marginLeft-16">
      <Toggle
        checked={showGrid}
        label="Show Grid"
        onChange={() => onShowGridChange(!showGrid)}
      />
      <div className="t-label-1">
        { `Selected ${toPercent(selectedRatio, 1)}` }
      </div>
    </div>
  );

  return (
    <>
      <Collapsible header={renderHeader()}>
        <div className="u-flexRow u-justifyCenter u-gap-24 u-marginBottom-16 u-marginTop-16">
          <RadioGroup
            label="Grid Color"
            name="gridLineColor"
            options={getOptions(LINE_COLORS)}
            value={gridLineColor}
            onChange={(e) => onGridLineColorChange(e.target.value)}
          />
          <RadioGroup
            label="Fill Color"
            name="gridFillColor"
            options={getOptions(FILL_COLORS)}
            value={gridFillColor}
            onChange={(e) => onGridFillColorChange(e.target.value)}
          />
        </div>
      </Collapsible>
    </>
  );
}

GridControls.propTypes = propTypes;

export default GridControls;
